

















import { computed, defineComponent, onUnmounted, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import config from "@/config";
import { EVENTS } from "@/const";
import MainNavigationBar from "@/components/MainNavigationBar";

export default defineComponent({
  name: "MainNavigationView",
  components: { MainNavigationBar },
  setup() {
    const hideMenuManual = ref(false);
    const { allowAccess } = useAuthUser();
    const showPoweredBy = computed(() => !config.featureHideScrileLink);

    const hideMenuHandler = (hide = false) => (hideMenuManual.value = hide);
    emitter.on<any>(EVENTS.MAIN_MENU_HIDE, hideMenuHandler);
    onUnmounted(() => emitter.off<any>(EVENTS.MAIN_MENU_HIDE, hideMenuHandler));

    return {
      showMenu: allowAccess,
      hideMenuManual,
      showPoweredBy,
    };
  },
});
